const ANCILLARY_TYPES = {
  FETCH_ANCILLARY_SERVICE_START: 'FETCH_ANCILLARY_SERVICE_START',
  FETCH_ANCILLARY_SERVICE_FAILURE: 'FETCH_ANCILLARY_SERVICE_FAILURE',
  FETCH_ANCILLARY_SERVICE_SUCCESS: 'FETCH_ANCILLARY_SERVICE_SUCCESS',
    
  UPDATE_ANCILLARY_SERVICE_START: 'UPDATE_ANCILLARY_SERVICE_START',
  UPDATE_ANCILLARY_SERVICE_FAILURE: 'UPDATE_ANCILLARY_SERVICE_FAILURE',
  UPDATE_ANCILLARY_SERVICE_SUCCESS: 'UPDATE_ANCILLARY_SERVICE_SUCCESS' 
}

export default ANCILLARY_TYPES;